import Icon, { IconProps } from '@atlaskit/icon';
import React, { ReactElement, useCallback } from 'react';

type CustomIconProps = Pick<IconProps, 'size' | 'label' | 'primaryColor'>;

export const CreateIconComponent = (
  glyph: ReactElement,
  defaultProps?: Partial<CustomIconProps>
): React.FunctionComponent<CustomIconProps> =>
  function CreateIconComponent(props) {
    const getGlyph = useCallback(() => glyph, []);
    // eslint-disable-next-line @atlaskit/design-system/no-custom-icons
    return <Icon glyph={getGlyph} {...defaultProps} {...props} />;
  };
